import React, { Component } from 'react';
import { connect } from 'react-redux';
import InstanceForm from './InstanceForm';
import { actionCreators } from '../actions/instances';
import { actionCreators as actionCreatorsContacts }  from '../actions/contacts';
import '../styles/AddInstancePage.css';

export class AddInstancePage extends Component {
    onSubmit = (instance, contact) => {
      const newContact = this.props.addContact(contact);
      newContact.then((value) => {
        instance.primaryContactId = value.id;
        this.props.addInstance(instance);
        this.props.history.push("/Instances");
    });
  };
  render() {
    return (
      <div>
        <h1 className="AddInstanceH1">Create New Instance</h1>
        <InstanceForm onSubmit={this.onSubmit} />
      </div>
    );
  }
}
  
const mapDispatchToProps = dispatch => ({
    addInstance: (instance) => dispatch(actionCreators.addInstance(instance)),
    addContact: (contact) => dispatch(actionCreatorsContacts.addContact(contact))
});
  
export default connect(
  undefined,
  mapDispatchToProps
)(AddInstancePage);


// WEBPACK FOOTER //
// ./src/components/AddInstancePage.js